import { isNumber } from 'lodash';

import type { TFilterItem } from '@/components/ReactDataGrid';

export const compareIds = <T extends number | string | boolean>(
  { id: a }: TFilterItem<T>,
  { id: b }: TFilterItem<T>,
): number => {
  if (isNumber(a) && isNumber(b)) {
    return a - b;
  }
  return String(a).localeCompare(String(b));
};

export const compareLabels = <T extends string | number | boolean>(
  { label: a }: TFilterItem<T>,
  { label: b }: TFilterItem<T>,
): number => a.localeCompare(b);

export const compareString = (
  { label: a }: TFilterItem<string | number | boolean>,
  { label: b }: TFilterItem<string | number | boolean>,
) => a.localeCompare(b);

export const setFilterData = <T extends number | string | boolean>(
  filterData: Map<T, TFilterItem<T>>,
  key: T | undefined,
  label?: string,
): void => {
  if (key !== undefined && !filterData.has(key)) {
    filterData.set(key, { id: key, label: label ?? String(key) });
  }
};

export const prepareFilterData = <T extends number | string | boolean>(
  filterData: Map<T, TFilterItem<T>>,
  sortBy: (a: TFilterItem<T>, b: TFilterItem<T>) => number = compareIds,
): Array<TFilterItem<T>> => {
  return Array.from(filterData.values()).sort(sortBy);
};
